import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  subcategories: [],
  products: [],
  loading: false,
  error: null,
  message: null,
};

export const subcategoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("subcategoriesRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("subcategoriesSuccess", (state, action) => {
      state.loading = false;
      state.subcategories = action.payload;
    })
    .addCase("subcategoriesFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("createSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("createSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subcategories = [...state.subcategories, action.payload];
      state.message = "Subcategory created successfully!";
    })
    .addCase("createSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("updateSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("updateSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subcategories = state.subcategories.map((subcategory) =>
        subcategory._id === action.payload._id ? action.payload : subcategory
      );
      state.message = "Subcategory updated successfully!";
    })
    .addCase("updateSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("deleteSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("deleteSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subcategories = state.subcategories.filter(
        (subcategory) => subcategory._id !== action.payload
      );
      state.message = "Subcategory deleted successfully!";
    })
    .addCase("deleteSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("getSubcategoryProductsRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("getSubcategoryProductsSuccess", (state, action) => {
      state.loading = false;
      state.products = action.payload;
    })
    .addCase("getSubcategoryProductsFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("clearMessages", (state) => {
      state.message = null;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
